import { useEffect, useState } from 'react';

export default function SectionTimeline() {
  const [activeSection, setActiveSection] = useState('hero');

  const sections = [
    { id: 'hero', label: 'Home', icon: 'ri-home-4-line' },
    { id: 'projects', label: 'My Work', icon: 'ri-folder-line' },
    { id: 'testimonials', label: 'Testimonials', icon: 'ri-chat-quote-line' },
    { id: 'about', label: 'About Me', icon: 'ri-user-line' },
    { id: 'about-me', label: 'My Journey', icon: 'ri-map-pin-line' },
    { id: 'philosophy', label: 'Design Philosophy', icon: 'ri-lightbulb-line' },
    { id: 'skills', label: 'Skills', icon: 'ri-code-s-slash-line' },
    { id: 'interests', label: 'Hobbies', icon: 'ri-heart-line' },
    { id: 'contact', label: 'Contact Me', icon: 'ri-mail-line' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight / 2;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i].id);
        if (section) {
          const sectionTop = section.offsetTop;
          if (scrollPosition >= sectionTop) {
            setActiveSection(sections[i].id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    if (sectionId === 'hero') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <div className="fixed right-8 top-1/2 -translate-y-1/2 z-50 hidden lg:block">
      <div className="relative">
        {/* Timeline Line */}
        <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-slate-300"></div>

        {/* Active Section Indicator */}
        <div
          className="absolute left-0 w-0.5 transition-all duration-500 ease-out"
          style={{
            backgroundColor: '#6b3d52',
            top: `${(sections.findIndex(s => s.id === activeSection) / sections.length) * 100}%`,
            height: `${100 / sections.length}%`,
          }}
        ></div>

        {/* Section Items */}
        <div className="relative flex flex-col gap-6">
          {sections.map((section) => {
            const isActive = activeSection === section.id;
            return (
              <button
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                className="group relative flex items-center gap-3 cursor-pointer whitespace-nowrap"
                aria-label={`Go to ${section.label}`}
              >
                {/* Dot */}
                <div
                  className={`w-3 h-3 rounded-full border-2 transition-all duration-300 flex-shrink-0 ${
                    isActive
                      ? 'scale-125'
                      : 'bg-slate-50 border-slate-400 group-hover:bg-slate-200 group-hover:scale-110'
                  }`}
                  style={isActive ? { 
                    backgroundColor: '#6b3d52', 
                    borderColor: '#6b3d52',
                    boxShadow: '0 4px 14px 0 rgba(107, 61, 82, 0.3)'
                  } : {}}
                ></div>

                {/* Label - only active has container */}
                {isActive ? (
                  <div className="bg-white rounded-full px-4 py-2 border border-slate-200 shadow-md transition-all duration-300">
                    <div className="flex items-center gap-2">
                      <i className={`${section.icon} text-xs`} style={{ color: '#6b3d52' }}></i>
                      <span className="text-xs font-semibold text-slate-800 transition-all duration-300">
                        {section.label}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="flex items-center gap-2 transition-all duration-300 group-hover:opacity-80">
                    <i className={`${section.icon} text-slate-500 text-xs`}></i>
                    <span className="text-xs font-medium text-slate-500 group-hover:text-slate-700 transition-all duration-300">
                      {section.label}
                    </span>
                  </div>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
